import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createFolder,
  createShareLinkFileFolder,
  deletePermissionsFileFolder,
  // getAllFolders,
  getAllFoldersDetails,
  getAllRootFolders,
  getChildFolder,
  getFolderHierarchy,
  getSharedDetails,
  grantPermissionFileFolder,
  moveFolder,
  movesFileFolder,
  updateFolder,
  updatePermissionsFileFolder,
} from "store/services/folders";
import { closeCenterModal } from "store/slices/CenterModal.slice";
import { openToast } from "store/slices/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

export const GetAllRootFoldersAction = createAsyncThunk(
  "folders/getAllRootFolders",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const response = await getAllRootFolders(payload);
      if (response.status === 1) {
        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetAllFoldersAction = createAsyncThunk(
  "folders/getAllFoldersDetails",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {

    const { isLoadMore, onError, ...rest } = payload;
    try {
      const response = await getAllFoldersDetails(rest);
      if (response.status === 1) {
        return fulfillWithValue({ isLoadMore, ...response });
      }
      onError?.(response);

      return rejectWithValue(response);
    } catch (error) {
      onError?.(error?.response?.data);
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetMyDriveAction = createAsyncThunk(
  "folders/getMyDrive",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { isLoadMore, ...rest } = payload;

      const response = await getAllFoldersDetails(rest);

      if (response.status === 1) {
        return fulfillWithValue({
          isLoadMore,
          ...response,
        });
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );

      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );

      return rejectWithValue(error);
    }
  },
);

export const GetMoveFoldersAction = createAsyncThunk(
  "folders/getAllFolders",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const response = await getAllFoldersDetails(payload);
      if (response.status === 1) {
        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

// export const GetFolderDetailsAction = createAsyncThunk(
//   "folders/getFolderDetails",
//   async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
//     try {
//       const response = await getFolderDetails(payload);
//       if (response.status === 1) {
//         return fulfillWithValue(response);
//       }
//       dispatch(
//         openToast({
//           type: "error",
//           message: getApiMessage(response?.statusCode),
//         }),
//       );
//       return rejectWithValue(response);
//     } catch (error) {
//       dispatch(
//         openToast({
//           type: "error",
//           message: error?.response?.data?.statusCode
//             ? getApiMessage(error?.response?.data?.statusCode)
//             : error?.message,
//         }),
//       );
//       return rejectWithValue(error);
//     }
//   },
// );

export const GetFolderHierarchyAction = createAsyncThunk(
  "folders/getFolderHierarchy",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const response = await getFolderHierarchy(payload);
      if (response.status === 1) {
        return fulfillWithValue(response);
      }
      // dispatch(
      //   openToast({
      //     type: "error",
      //     message: getApiMessage(response?.statusCode),
      //   }),
      // );
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const CreateFolderAction = createAsyncThunk(
  "folders/createFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    // eslint-disable-next-line no-unused-vars
    const { onSuccess, onError, sortBy, sortOrder, ...rest } = payload;
    try {
      const response = await createFolder(rest);
      if (response.status === 1) {
        onSuccess?.();
        dispatch(closeCenterModal());
        return fulfillWithValue(response);
      }
      onError?.(response);
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const UpdateFolderAction = createAsyncThunk(
  "folders/updateFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const response = await updateFolder(rest);
      if (response.status === 1) {
        onSuccess?.();
        dispatch(closeCenterModal());
        return fulfillWithValue(response);
      }
      onError?.(response);
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const MoveFolderAction = createAsyncThunk(
  "folders/moveFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSuccess, onError, folderId, ...rest } = payload;
      const response = await moveFolder({ folderId, ...rest });
      if (response.status === 1) {
        onSuccess?.();
        dispatch(closeCenterModal());
        return fulfillWithValue(response);
      }
      onError?.(response);
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetChildFolderAction = createAsyncThunk(
  "folders/getChildFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const response = await getChildFolder(payload);
      if (response.status === 1) {
        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GrantPermissionFileFolderAction = createAsyncThunk(
  "folders/grantPermissionFileFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const response = await grantPermissionFileFolder(rest);
      if (response.status === 1) {
        onSuccess?.();
        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      onError?.();
      return rejectWithValue(response);
    } catch (error) {
      onError?.();
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetSharedDetailsAction = createAsyncThunk(
  "folders/getSharedDetails",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const response = await getSharedDetails(rest);
      if (response.status === 1) {
        onSuccess?.(response?.response);
        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      onError?.();
      return rejectWithValue(response);
    } catch (error) {
      onError?.();
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const UpdatePermissionsFileFolderAction = createAsyncThunk(
  "folders/updatePermissionsFileFolder",
  async (
    payload,
    { rejectWithValue, dispatch, getState, fulfillWithValue },
  ) => {
    const { onSuccess, onError, ...rest } = payload;

    try {
      const response = await updatePermissionsFileFolder(rest);

      if (response.status === 1) {
        const profileId = getState().profile?.profile?.id;

        onSuccess?.();

        return fulfillWithValue({
          profileId,
          ...response.response,
        });
      }

      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );

      onError?.();
      return rejectWithValue(response);
    } catch (error) {
      onError?.();

      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );

      return rejectWithValue(error);
    }
  },
);

export const DeletePermissionsFileFolderAction = createAsyncThunk(
  "folders/deletePermissionsFileFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const response = await deletePermissionsFileFolder(rest);
      if (response.status === 1) {
        onSuccess?.();
        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      onError?.();
      return rejectWithValue(response);
    } catch (error) {
      onError?.();
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const CreateShareLinkFileFolderAction = createAsyncThunk(
  "folders/createShareLinkFileFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const response = await createShareLinkFileFolder(rest);
      if (response.status === 1) {
        onSuccess?.(response?.response);
        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      onError?.();
      return rejectWithValue(response);
    } catch (error) {
      onError?.();
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const MovesFileFolderAction = createAsyncThunk(
  "folders/movesFileFolder",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await movesFileFolder(rest);
      if (res.status === 1) {
        dispatch(closeCenterModal());
        onSuccess?.();
        return fulfillWithValue(res);
      }

      onError?.(res);
      return rejectWithValue(res);
    } catch (error) {
      onError?.(error?.response?.data);
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.res?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
